import clsx from 'clsx';
import dayjs from 'dayjs';

import useUser from '@/utils/hooks/swr/useUser';
import useTranslation from '@/utils/hooks/translation/useTranslation';

// Components
import Icon from '@/components/base/Icon';

const PostingHabitsLegend = ({ data, competitor, isExport }) => {
    const { t } = useTranslation('analytics');

    let timeWithMostPosts = data?.graphData[0];
    for (const time of data?.graphData ?? []) {
        if (time?.value > timeWithMostPosts?.value) {
            timeWithMostPosts = time;
        }
    }

    const { user } = useUser({
        revalidateOnMount: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false
    });

    return (
        <div className="mb-3 mt-5 flex w-full flex-wrap items-center justify-between gap-2">
            <div
                className={clsx('flex items-center gap-2 rounded-2xl bg-icoGray-300 px-3 py-2', {
                    'dark:bg-icoDarkMode-beton': !isExport
                })}>
                <Icon
                    icon={data?.iconHighestValue}
                    className={clsx(
                        'flex h-4 w-4 items-center justify-center rounded-full bg-icoYellow p-2 text-xxs text-white',
                        {
                            'dark:bg-icoYellow/20': !isExport
                        }
                    )}
                />
                <p className="text-xs">
                    {t('chart.posting_habits.most_posts_on', {
                        competitor: competitor?.slug,
                        date: t(`commons:days.${timeWithMostPosts?.day}`),
                        time: dayjs(`01/01/2000 ${timeWithMostPosts?.date}`).format(
                            user?.settings?.time_format === '12' ? 'ha' : 'H'
                        )
                    })}
                </p>
            </div>
            <div
                className={clsx('flex items-center gap-2 rounded-2xl bg-icoGray-300 px-3 py-2', {
                    'dark:bg-icoDarkMode-beton': !isExport
                })}>
                <div className="h-3.5 w-3.5 rounded-full bg-icoBlue" />
                <p className="text-xs">{t('chart.posting_habits.more_posts')}</p>
                <div className="ml-3 h-2 w-2 rounded-full bg-[#b4dcff]" />
                <p className="text-xs">{t('chart.posting_habits.less_posts')}</p>
            </div>
        </div>
    );
};

export default PostingHabitsLegend;
